import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResGetAllArtical {
  message: string;
  result: {
    ALWAYS_OPEN: string;
    ARTICAL_CATEGORY: number;
    ARTICAL_CREATID: string;
    ARTICAL_DATE: Date;
    ARTICAL_DETAIL: string;
    ARTICAL_END: Date;
    ARTICAL_ID: string;
    ARTICAL_ORIGINAL: string;
    ARTICAL_PIC: string;
    ARTICAL_READED: number;
    ARTICAL_START: Date;
    ARTICAL_STATUS: number;
    ARTICAL_TITAL: string;
    CREATE_BY: string;
    CREATE_NAME: string;
    POLL_ID: string;
  };
  success: boolean;
}

interface ResGetCategoryArtical {
  message: string;
  result: [
    {
      CATEGORY_ENG: string;
      CATEGORY_ID: number;
      CATEGORY_NAME: string;
    }
  ]
  success: boolean;
}

interface ResCreateArtical {
  message: string;
  result: {
    update: Date;
  }
  success: boolean;
}

interface ResUpdateStatusArtical {
  message: string;
  result: {
    update: Date;
  }
  success: boolean;
}

interface ResEditArticalById {
  message: string;
  result: {
    createtime: Date;
  }
  success: boolean;
}

interface ResDeleteArticalById {
  message: string;
  result: {
    updatetime: Date;
  }
  success: boolean;
}

interface ResGetPollById {
  message: string;
  result: {
    ARTICAL_ID: string;
    ARTICAL_TITAL: string;
    VOTE_COUNT: number;
    DETAIL_POLL: [
      {
        ARTICAL_ID: string;
        CREATE_BY: string;
        CREATE_DATE: Date;
        POLL_CHOICE: [
          {
            OPTION_ID: number;
            OPTION_VALUE: string;
            POLL_ID: string;
            POLL_PERCEN: number;
          }
        ]
        POLL_END: Date;
        POLL_ID: string;
        POLL_QUESTION: string;
        POLL_START: Date;
        POLL_STATUS: number;
      }
    ]
  }
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ArticalManagementService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllArtical() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllArtical>(environment.URL + '/manage_admin/getAllArtical', { headers: headers });
  }

  getCategoryArtical() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetCategoryArtical>(environment.URL + '/manage_admin/getCategoryArtical', { headers: headers });
  }

  createArtical(a) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;

    if (a.pollForm) {
      const poll = {
        POLL_QUESTION: a.pollForm.pollQuestion,
        POLL_START: a.pollForm.pollTime[0],
        POLL_END: a.pollForm.pollTime[1],
        POLL_CHOICE: [
          {
            ID: 1,
            VALUE: a.pollForm.pollChoice1
          }, {
            ID: 2,
            VALUE: a.pollForm.pollChoice2
          }
        ]
      }
      formData.append('POLL_DELTAIL', JSON.stringify(poll));
    } else {
      formData.append('POLL_DELTAIL', '');
    }

    if (a.articalForm.articalAlwaysOpen !== 'true') {
      formData.append('ARTICAL_START', a.articalForm.articalDate[0]);
      formData.append('ARTICAL_END', a.articalForm.articalDate[1]);
    } else {
      formData.append('ARTICAL_START', '');
      formData.append('ARTICAL_END', '');
    }

    formData.append('ALWAYS_OPEN', a.articalForm.articalAlwaysOpen);
    formData.append('ARTICAL_TITAL', a.articalForm.articalTital);
    formData.append('ARTICAL_DETAIL', a.articalForm.articalContent);
    formData.append('ARTICAL_PIC', a.articalForm.articalCover);
    formData.append('ARTICAL_CATEGORY', a.articalForm.articalCategory);

    if (a.articalForm.centerId) {
      if (a.articalForm.centerId.length > 0) {
        for (let i = 0; i < a.articalForm.centerId.length; i++) {
          const el = a.articalForm.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResCreateArtical>(environment.URL + '/manage_admin/createArtical', formData, { headers: headers });
  }

  editArticalById(a) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;

    // console.log(a);

    if (a.havePoll) {
      if (a.pollForm && (a.pollStatus === undefined || a.pollStatus === null || a.pollStatus === '')) {
        // console.log('create');

        const poll = {
          POLL_QUESTION: a.pollForm.pollQuestion,
          POLL_START: a.pollForm.pollTime[0],
          POLL_END: a.pollForm.pollTime[1],
          POLL_CHOICE: [
            {
              ID: 1,
              VALUE: a.pollForm.pollChoice1
            }, {
              ID: 2,
              VALUE: a.pollForm.pollChoice2
            }
          ]
        }

        formData.append('POLL_DELTAIL', JSON.stringify(poll));
        formData.append('TYPE', 'create');
      }

      if (a.pollForm && a.pollStatus === 0) {
        // console.log('edit');
        const poll = {
          POLL_ID: a.pollOptionIds[0].POLL_ID,
          POLL_QUESTION: a.pollForm.pollQuestion,
          POLL_START: a.pollForm.pollTime[0],
          POLL_END: a.pollForm.pollTime[1],
          ARTICAL_ID: a.articalId,
          POLL_CHOICE: [
            {
              OPTION_ID: a.pollOptionIds[0].OPTION_ID,
              OPTION_VALUE: a.pollForm.pollChoice1
            }, {
              OPTION_ID: a.pollOptionIds[1].OPTION_ID,
              OPTION_VALUE: a.pollForm.pollChoice2
            }
          ]
        }

        formData.append('POLL_DELTAIL', JSON.stringify(poll));
        formData.append('TYPE', 'edit');
      } else if (a.pollForm && a.pollStatus === 1) {
        // console.log('enable');
        formData.append('TYPE', 'enable');
        formData.append('POLL_DELTAIL', '');
      }
    } else {
      if (!a.pollForm || (a.pollForm && a.pollStatus === 1)) {
        // console.log('disable');
        formData.append('TYPE', 'disable');
        formData.append('POLL_DELTAIL', '');
      } else if (a.pollStatus === 0) {
        // console.log('disable');
        formData.append('TYPE', 'disable');
        formData.append('POLL_DELTAIL', '');
      }
    }

    if (a.articalForm.articalAlwaysOpen !== 'true') {
      formData.append('ARTICAL_START', a.articalForm.articalDate[0]);
      formData.append('ARTICAL_END', a.articalForm.articalDate[1]);
    } else {
      formData.append('ARTICAL_START', '');
      formData.append('ARTICAL_END', '');
    }

    if (typeof (a.articalForm.articalCover) === 'object') {
      formData.append('ARTICAL_PIC', a.articalForm.articalCover);
    }

    formData.append('ARTICAL_ID', a.articalId);
    formData.append('ALWAYS_OPEN', a.articalForm.articalAlwaysOpen);
    formData.append('ARTICAL_TITAL', a.articalForm.articalTital);
    formData.append('ARTICAL_DETAIL', a.articalForm.articalContent);
    formData.append('ARTICAL_CATEGORY', a.articalForm.articalCategory);

    if (a.articalForm.centerId) {
      if (a.articalForm.centerId.length > 0) {
        for (let i = 0; i < a.articalForm.centerId.length; i++) {
          const el = a.articalForm.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResEditArticalById>(environment.URL + '/manage_admin/editArticalById', formData, { headers: headers });
  }

  updateStatusArtical(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResUpdateStatusArtical>(environment.URL + '/manage_admin/updateStatusArtical', body, { headers: headers });
  }

  getPollById(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetPollById>(environment.URL + '/manage_admin/getPollById?ARTICAL_ID=' + id, { headers: headers });
  }

  deleteArticalById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    //
    return this.http.post<ResDeleteArticalById>(environment.URL + '/manage_admin/deleteArticalById', body, { headers: headers });
  }
}
